export default __webpack_public_path__ + "static/media/pic3.2ba36045.jpg";